import { IconButton, Stack, Typography } from "@mui/material";
import { ReuseTooltip } from "../../../../ui";
import { DeleteIcon } from "../../../../images";
import { KeyTitleAddItemBlock } from "../../../KeyTitles/KeyTitleAddItemBlock";
import { JobTitlesType } from "../../../../../types/enums";
import { AddedItem } from "../../../../../types/apiTypes";

type Props = {
  subCids: AddedItem[];
  isLoading: boolean;
  removeSubCidHandler: (cid: string, subSid: string) => void;
  addSubCidHandler: (
    subSid: string,
    cid: string,
    onSuccess: () => void,
  ) => void;
  isAllowedAddCid: boolean;
  cid: string;
};

export const SubCIDBlock = ({
  subCids,
  isLoading,
  addSubCidHandler,
  removeSubCidHandler,
  isAllowedAddCid,
  cid,
}: Props) => {
  return (
    <Stack gap={"16px"} flexDirection={"row"} alignItems={"center"}>
      <Typography
        variant="body1"
        color="custom.textDarkBlue"
        sx={{
          color: "#464646",
          maxWidth: "78px",
          width: "100%",
        }}
      >
        Sub-CID(s)
      </Typography>
      <Stack flexDirection={"row"} gap={"8px"} flexWrap={"wrap"}>
        {subCids.map(({ name, isAdded }) => (
          <Stack key={name} flexDirection="row" gap="4px">
            <Stack
              sx={{
                padding: "4px",
                borderRadius: "6px",
                backgroundColor: "#F4F5F7",
                flexDirection: "row",
                alignItems: "center",
                flex: 1,
                border: `1px solid "#DEDEDE"`,
              }}
            >
              <Stack
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "4px",
                  paddingLeft: "4px",
                }}
              >
                <Typography
                  component="span"
                  variant="body1"
                  color="custom.textDarkBlue"
                  sx={{
                    whiteSpace: "nowrap",
                    fontWeight: 500,
                  }}
                >
                  {name}
                </Typography>
              </Stack>

              <Stack flexDirection="row" flexWrap="nowrap" paddingLeft="4px">
                {isAdded && (
                  <ReuseTooltip text="Delete SubCid">
                    <IconButton
                      sx={{
                        height: "24px",
                        width: "24px",
                      }}
                      disabled={isLoading}
                      onClick={() => removeSubCidHandler(cid, name)}
                    >
                      <DeleteIcon
                        height={"16px"}
                        width={"16px"}
                        color={"#9B9B9B"}
                      />
                    </IconButton>
                  </ReuseTooltip>
                )}
              </Stack>
            </Stack>
          </Stack>
        ))}
        <KeyTitleAddItemBlock
          isDisabled={isLoading || !isAllowedAddCid}
          titleType={JobTitlesType.approved}
          roleId={cid}
          isReachedLimit={true}
          customAddHandler={addSubCidHandler}
          btnText={"Add Sub-CID"}
          placeholder={"Enter Sub-CID"}
        />
      </Stack>
    </Stack>
  );
};
